import { render, staticRenderFns } from "./chat-info-panel.vue?vue&type=template&id=6192e586"
import script from "./chat-info-panel.vue?vue&type=script&lang=js"
export * from "./chat-info-panel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6192e586')) {
      api.createRecord('6192e586', component.options)
    } else {
      api.reload('6192e586', component.options)
    }
    module.hot.accept("./chat-info-panel.vue?vue&type=template&id=6192e586", function () {
      api.rerender('6192e586', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/pages/conversation-list/chat-info-panel.vue"
export default component.exports